// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__r4lah","inner":"Footer_inner__ouGyM"};